import { render, staticRenderFns } from "./JobCards.vue?vue&type=template&id=2a3fe0e8&scoped=true&"
import script from "./JobCards.vue?vue&type=script&lang=js&"
export * from "./JobCards.vue?vue&type=script&lang=js&"
import style0 from "./JobCards.vue?vue&type=style&index=0&id=2a3fe0e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3fe0e8",
  null
  
)

export default component.exports